/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const f = 'fixed';
	const serchBox = () => {
		if($('.product-search-box').length) {
			var $switch = $('.product-search-box .__toggle');

			$switch.on('click', function(){
				$(this).toggleClass(a);
				$('.product-search-box .__toggleBlock').stop().slideToggle(400);
			});

			const clear = $('.js-product-search-clear');
			const categorySelect = $('.js-product-search-category select');
			const selectBlock = (_block,_val) => {
				let selectClass = '.'+_block;
				if(categorySelect.val() == _val) {
					$('.product-search-box .__toggle').addClass(a);
					$('.product-search-box .__toggleBlock').css('display','block');
					$(selectClass).removeClass('di_none');
				}
			};
			selectBlock('js-product-search-machinery','machinery');
			selectBlock('js-product-search-excippients','excipients');
			selectBlock('js-product-search-preservation','preservation');
			selectBlock('js-product-search-laboratory','laboratory');
			selectBlock('js-product-search-additive_pharma','additive_pharma');
			selectBlock('js-product-search-additive_food','additive_food');
			categorySelect.change(function(){
				$('.product-search-box-item input').prop('checked', false);
				$('.js-product-search-block').addClass('di_none');
				let categoryval = '.js-product-search-'+categorySelect.val();
				if($(categoryval).length) {
					$(categoryval).removeClass('di_none');
				}
			});
			clear.on('click', function(){
				$('.product-search-box-item input').prop('checked', false);
			});
			// パラメータチェック
			let urlParam = location.search.substring(1);
			let paramArray = [];
			if(urlParam) {
				let param = urlParam.split('&');
				for(let i = 0; i < param.length; i++) {
					let paramItem = param[i].split('=');
					paramArray[paramItem[0]] = paramItem[1];
				}
			}
			// キーワード初期表示描画
			if(paramArray.p_keyword) {
				$('.js-product-search-keyword').val(decodeURI(paramArray.p_keyword.replaceAll("+", " ")));
			}
			// サブミット
			$('.js-product-search-submit').on('click', function(){
				let searchinputVal = $('.js-product-search-keyword').val().replaceAll(/[\"]/g,"").replaceAll(/[\']/g,"");
				let kewords = searchinputVal.normalize("NFKC").split(/\s/);
				let kewordVal = searchinputVal.normalize("NFKC");
				$('.js-product-search-keyword').val(kewordVal);
				let keywordInputs;
				for(let i = 0; i < kewords.length; i++) {
					if(i == 0) {
						keywordInputs = '<input name="p_keyword_1" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 1) {
						keywordInputs = '<input name="p_keyword_2" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 2) {
						keywordInputs = '<input name="p_keyword_3" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 3) {
						keywordInputs = '<input name="p_keyword_4" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 4) {
						keywordInputs = '<input name="p_keyword_5" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 5) {
						keywordInputs = '<input name="p_keyword_6" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 6) {
						keywordInputs = '<input name="p_keyword_7" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 7) {
						keywordInputs = '<input name="p_keyword_8" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 8) {
						keywordInputs = '<input name="p_keyword_9" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 9) {
						keywordInputs = '<input name="p_keyword_10" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					}
				}
				$(this).parents('form').submit();
			});
			$('.js-product-search-keyword').keypress(function(e){
				if(e.keyCode == 13) {
					let searchinputVal = $('.js-product-search-keyword').val().replaceAll(/[\"]/g,"").replaceAll(/[\']/g,"");
					let kewords = searchinputVal.normalize("NFKC").split(/\s/);
					let kewordVal = searchinputVal.normalize("NFKC");
					$('.js-product-search-keyword').val(kewordVal);
					let keywordInputs;
					for(let i = 0; i < kewords.length; i++) {
						if(i == 0) {
							keywordInputs = '<input name="p_keyword_1" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 1) {
							keywordInputs = '<input name="p_keyword_2" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 2) {
							keywordInputs = '<input name="p_keyword_3" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 3) {
							keywordInputs = '<input name="p_keyword_4" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 4) {
							keywordInputs = '<input name="p_keyword_5" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 5) {
							keywordInputs = '<input name="p_keyword_6" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 6) {
							keywordInputs = '<input name="p_keyword_7" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 7) {
							keywordInputs = '<input name="p_keyword_8" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 8) {
							keywordInputs = '<input name="p_keyword_9" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 9) {
							keywordInputs = '<input name="p_keyword_10" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						}
					}
					$(this).parents('form').submit();
					return false;
				}
			});
		}
	};
	const relatedProduct = () => {
		if($('.js-related-product').length) {
			const getJSONkey = (_id) => {
				return $.getJSON(`/ajax/${_id}.json`);
			};
			const getJSONitem = (_key) => {
				return $.getJSON(`/ajax/product/detail/${_key}.json`);
			};
			// 日英だし分け
			let directory,itemName;
			if(!(location.pathname.split('/')[1] === 'english')) {
				directory = '/product/';
			} else {
				directory = '/english/product/';
			}
			// htmlblock
			const htmlBlock = (_data) => {
				// console.log('_data',_data);
				let HTML;
				if(!(location.pathname.split('/')[1] === 'english')) {
					itemName = _data.rt_bn_related_product_detail[0].cf_ps_name_ja;
				} else {
					itemName = _data.rt_bn_related_product_detail[0].cf_ps_name_en;
				}
				HTML = '<li class="pure-u-1-4 pure-u-md-1-1 space-u-60-child">'+
				'<a href="'+directory + _data.rt_bn_related_product_detail[0].cf_ps_child_category1.cf_pc_parent_code+'/'+_data.rt_bn_related_product_detail[0].cf_ps_child_category1._key+'/'+_data.rt_bn_related_product_detail[0]._key+'.html" class="di_block">'+
				'<figure class=""><img src="/product_file/file/'+_data.rt_bn_related_product_detail[0].cf_ps_img+'" class="width-u-100" alt="'+itemName+'"></figure>'+
				'<p class="fw_bold mt10">'+itemName+'</p></a>'+
				'</li>';
				$('.js-related-product').append(HTML);
			};
			// json描画
			let id = location.pathname.replace('/english','').replace('.html','');
			getJSONkey(id).done((data) => {
				console.log('data',data);
				if(!(data.rt_bn_related_product[0].cf_ps_related_product1)) {
					$('.js-related-product').parents('section').addClass('di_none');
				} else {
					getJSONitem(data.rt_bn_related_product[0].cf_ps_related_product1._key).done((pro1data) => {
						htmlBlock(pro1data);
						if(data.rt_bn_related_product[0].cf_ps_related_product2) {
							getJSONitem(data.rt_bn_related_product[0].cf_ps_related_product2._key).done((pro2data) => {
								htmlBlock(pro2data);
								if(data.rt_bn_related_product[0].cf_ps_related_product3) {
									getJSONitem(data.rt_bn_related_product[0].cf_ps_related_product3._key).done((pro3data) => {
										htmlBlock(pro3data);
										if(data.rt_bn_related_product[0].cf_ps_related_product4) {
											getJSONitem(data.rt_bn_related_product[0].cf_ps_related_product4._key).done((pro4data) => {
												htmlBlock(pro4data);
											});
										}
									});
								}
							});
						}
					});
				}
			});
		}
	};
	const lineupTable = () => {
		if($('.js-lineup-table').length) {
			// 日英だし分け
			let directory;
			if(!(location.pathname.split('/')[1] === 'english')) {
				directory = '/ja/';
			} else {
				directory = '/en/';
			}
			// id取得
			let id = location.pathname.split('/').pop().replace('.html','');
			let HTML;
			let remark1,remark2,itemName,itemLink,itemImg,itemToggle;
			if(!($('.product-detail-preservation').length)) {
				if(location.pathname.split('/')[1] === 'english') {
					itemToggle = 'List';
				} else {
					itemToggle = '一覧';
				}
			} else {
				if(location.pathname.split('/')[1] === 'english') {
					itemToggle = 'View details';
				} else {
					itemToggle = '詳細を見る';
				}
			}
			const getJSONlineup = () => {
				return $.getJSON(`${directory}ajax/product/detail/${id}/lineup.json`);
			};
			getJSONlineup().done((data) => {
				console.log('data',data.rt_bn_lineup_list);
				if(!(data.rt_bn_lineup_list.length)) {
					$('.js-lineup-table').parents('.mod-spacer-section').addClass('di_none');
				} else {
					for(let i = 0; i < data.rt_bn_lineup_list.length; i++) {
						if(data.rt_bn_lineup_list[i].cf_pl_output_class === 'T') {
							if(!(i == 0)) {
								HTML += '</table></div></div></div></div>';
								$('.js-lineup-table').append(HTML);
							}
							if(!(data.rt_bn_lineup_list[i].cf_pl_element_under_remarks)) {
								if(!(data.rt_bn_lineup_list[i].cf_pl_accordion == '1')) {
									remark2 = '<div><div class="pure-g"><div class="pure-u-1-1 __remark"></div>';
								} else {
									remark2 = '<div class="__toggleWrap"><div class="pure-g"><div class="pure-u-1-1 __remark __toggleBlock" style="display:none;"></div>';
								}
							} else {
								if(!(data.rt_bn_lineup_list[i].cf_pl_accordion == '1')) {
									remark2 = '<div><div class="pure-g"><div class="pure-u-1-1 __remark"><p class="mod-spacer">'+data.rt_bn_lineup_list[i].cf_pl_element_under_remarks+'</p></div>';
								} else {
									remark2 = '<div class="__toggleWrap"><div class="pure-g"><div class="pure-u-1-1 __remark __toggleBlock" style="display:none;"><p class="mod-spacer">'+data.rt_bn_lineup_list[i].cf_pl_element_under_remarks+'</p></div>';
								}
							}
							HTML = remark2;
							if(!(location.pathname.split('/')[1] === 'english')) {
								if(!(data.rt_bn_lineup_list[i].cf_pl_accordion == '1')) {
									HTML += '<div class="pure-u-1-1 __content"><h2 class="mod-head02 mod-spacer"><span class="__jpBig">'+data.rt_bn_lineup_list[i].cf_pl_label_name+'</span></h2>';
								} else {
									HTML += '<div class="pure-u-1-1 __content"><h2 class="mod-head02 mod-spacer mb10"><span class="__jpBig">'+data.rt_bn_lineup_list[i].cf_pl_label_name+'</span></h2><div class="ta_center mb40 mt10"><a class="__toggle">'+itemToggle+'<svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_bottom" /></svg></a></div>';
								}
							} else {
								if(!(data.rt_bn_lineup_list[i].cf_pl_accordion == '1')) {
									HTML += '<div class="pure-u-1-1 __content"><h2 class="mod-head02 mod-spacer"><span class="__en">'+data.rt_bn_lineup_list[i].cf_pl_label_name+'</span></h2>';
								} else {
									HTML += '<div class="pure-u-1-1 __content"><h2 class="mod-head02 mod-spacer mb10"><span class="__en">'+data.rt_bn_lineup_list[i].cf_pl_label_name+'</span></h2><div class="ta_center mb40 mt10"><a class="__toggle">'+itemToggle+'<svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_bottom" /></svg></a></div>';
								}
							}
							if(!(data.rt_bn_lineup_list[i].cf_pl_label_side_remarks)) {
								remark1 = '';
							} else {
								if(!(data.rt_bn_lineup_list[i].cf_pl_accordion == '1')) {
									remark1 = '<p class="mb40">'+data.rt_bn_lineup_list[i].cf_pl_label_side_remarks+'</p>';
								} else {
									remark1 = '<p class="mb40 __toggleBlock" style="display:none;">'+data.rt_bn_lineup_list[i].cf_pl_label_side_remarks+'</p>';
								}
							}
							HTML += remark1;
							if(!(data.rt_bn_lineup_list[i].cf_pl_accordion == '1')) {
								HTML += '<div class="mod-tblWrap"><table class="mod-tbl01"><tr>';
							} else {
								HTML += '<div class="mod-tblWrap __toggleBlock" style="display:none;"><table class="mod-tbl01"><tr>';
							}
							for(let j = 1; j < 16; j++) {
								itemName = 'cf_pl_item_'+j;
								itemLink = 'cf_pl_link_'+j;
								itemImg = 'rt_cf_pl_img_'+j;
								if(!(data.rt_bn_lineup_list[i][itemLink])) {
									if(!(data.rt_bn_lineup_list[i][itemName])) {
										if(data.rt_bn_lineup_list[i][itemImg]) {
											HTML += '<th><img src="'+data.rt_bn_lineup_list[i][itemImg].src+'" class="width-u-100"></th>'
										}
									} else {
										if(!(data.rt_bn_lineup_list[i][itemImg])) {
											HTML += '<th>'+data.rt_bn_lineup_list[i][itemName]+'</th>'
										} else {
											HTML += '<th>'+data.rt_bn_lineup_list[i][itemName]+'<img src="'+data.rt_bn_lineup_list[i][itemImg].src+'" class="width-u-100 mt10"></th>'
										}
									}
								} else {
									if(!(data.rt_bn_lineup_list[i][itemName])) {
										if(data.rt_bn_lineup_list[i][itemImg]) {
											HTML += '<th><a href="'+data.rt_bn_lineup_list[i][itemLink]+'" class="mod-a-text03"><img src="'+data.rt_bn_lineup_list[i][itemImg].src+'" class="width-u-100 mt10"></a></th>'
										}
									} else {
										if(!(data.rt_bn_lineup_list[i][itemImg])) {
											HTML += '<th><a href="'+data.rt_bn_lineup_list[i][itemLink]+'" class="mod-a-text03">'+data.rt_bn_lineup_list[i][itemName]+'</a></th>'
										} else {
											HTML += '<th><a href="'+data.rt_bn_lineup_list[i][itemLink]+'" class="mod-a-text03">'+data.rt_bn_lineup_list[i][itemName]+'<img src="'+data.rt_bn_lineup_list[i][itemImg].src+'" class="width-u-100 mt10"></th>'
										}
									}
								}
							}
							HTML += '</tr>';
						} else {
							HTML += '<tr>';
							for(let j = 1; j < 16; j++) {
								itemName = 'cf_pl_item_'+j;
								itemLink = 'cf_pl_link_'+j;
								itemImg = 'rt_cf_pl_img_'+j;
								if(!(data.rt_bn_lineup_list[i][itemLink])) {
									if(!(data.rt_bn_lineup_list[i][itemName])) {
										if(data.rt_bn_lineup_list[i][itemImg]) {
											HTML += '<td><img src="'+data.rt_bn_lineup_list[i][itemImg].src+'" class="width-u-100"></td>'
										}
									} else {
										if(!(data.rt_bn_lineup_list[i][itemImg])) {
											HTML += '<td>'+data.rt_bn_lineup_list[i][itemName]+'</td>'
										} else {
											HTML += '<td>'+data.rt_bn_lineup_list[i][itemName]+'<img src="'+data.rt_bn_lineup_list[i][itemImg].src+'" class="width-u-100 mt10"></td>'
										}
									}
								} else {
									if(!(data.rt_bn_lineup_list[i][itemName])) {
										if(data.rt_bn_lineup_list[i][itemImg]) {
											HTML += '<td><a href="'+data.rt_bn_lineup_list[i][itemLink]+'" class="mod-a-text03"><img src="'+data.rt_bn_lineup_list[i][itemImg].src+'" class="width-u-100 mt10"></a></td>'
										}
									} else {
										if(!(data.rt_bn_lineup_list[i][itemImg])) {
											HTML += '<td><a href="'+data.rt_bn_lineup_list[i][itemLink]+'" class="mod-a-text03">'+data.rt_bn_lineup_list[i][itemName]+'</a></td>'
										} else {
											HTML += '<td><a href="'+data.rt_bn_lineup_list[i][itemLink]+'" class="mod-a-text03">'+data.rt_bn_lineup_list[i][itemName]+'<img src="'+data.rt_bn_lineup_list[i][itemImg].src+'" class="width-u-100 mt10"></td>'
										}
									}
								}
							}
							HTML += '</tr>';
						}
					}
					HTML += '</table></div></div></div></div>';
					$('.js-lineup-table').append(HTML);
					// 出力データにクリックイベント
					$(document).on('click', '.__toggle', function(event){
						$(this).toggleClass(a);
						$(this).parents('.__toggleWrap').find('.__toggleBlock').stop().slideToggle(400);
					});
				}
			});
		}
	};
	const modal = () => {
		if($('.js-modal-btn').length) {
			var scrollTopNow;
			$('.js-modal-btn').on('click', function(event){
				var imgs = $(this).data('imgs');
				$('.js-modal-overlay').addClass(a);
				$('.js-modal-content').html(
					'<div class="p40">' +
					'<img src="/images/product/excipients/'+ imgs +'.jpg" class="width-u-100">' +
					'</div>'
				);
				scrollTopNow = $(window).scrollTop();
				$('body').addClass(f);
				$( '.container' ).css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				event.preventDefault();
			});
			$('.js-modal-closeBtn').on('click', function(event){
				$('.js-modal-content').html('');
				$('.js-modal-overlay').removeClass(a);
				$('body').removeClass(f);
				$( '.container' ).css( {
					position: 'static',
				} );
				$(window).scrollTop(scrollTopNow);
				event.preventDefault();
			});

			$('.js-modal-back').on('click', function(event){
				$('.js-modal-content').html('');
				$('.js-modal-overlay').removeClass(a);
				$('body').removeClass(f);
				$( '.container' ).css( {
					position: 'static',
				} );
				$(window).scrollTop(scrollTopNow);
				event.preventDefault();
			});
		}
	};
	
	serchBox();
	relatedProduct();
	lineupTable();
	modal();

})(window.jQuery, window.FUNCTIONS);
$(window).on('load', function(){
	const a = 'is-active'
	const tabChange = () => {
		if($('.product-tab-btn').length) {
			let tabs = $('.product-tab-btn');
			const $hash = location.hash;
			$('.product-tab-content').removeClass(a);
			$('.product-tab-btn').removeClass(a);
			if ($hash.length) {
				let pos = $('.product-tabHead').offset().top;
				if($(window).width() < 768) {
					pos -= 60;
				} else {
					pos -= 90;
				}
				$('html,body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
				if ($hash.replace('#', '') === 'process01') {
					$('.product-tab-content').eq(0).addClass(a);
					$('.product-tab-btn').eq(0).addClass(a);
				} else if ($hash.replace('#', '') === 'process02') {
					$('.product-tab-content').eq(1).addClass(a);
					$('.product-tab-btn').eq(1).addClass(a);
				} else if ($hash.replace('#', '') === 'process03') {
					$('.product-tab-content').eq(2).addClass(a);
					$('.product-tab-btn').eq(2).addClass(a);
				} else if ($hash.replace('#', '') === 'process04') {
					$('.product-tab-content').eq(3).addClass(a);
					$('.product-tab-btn').eq(3).addClass(a);
				} else if ($hash.replace('#', '') === 'process06') {
					$('.product-tab-content').eq(4).addClass(a);
					$('.product-tab-btn').eq(4).addClass(a);
				} else if ($hash.replace('#', '') === 'process07') {
					$('.product-tab-content').eq(5).addClass(a);
					$('.product-tab-btn').eq(5).addClass(a);
				} else if ($hash.replace('#', '') === 'process08') {
					$('.product-tab-content').eq(6).addClass(a);
					$('.product-tab-btn').eq(6).addClass(a);
				}
			} else {
				$('.product-tab-content').eq(0).addClass(a);
				$('.product-tab-btn').eq(0).addClass(a);
			}
			tabs.on('click', function() {
				tabs.removeClass(a);
				$(this).addClass(a);
				const index = tabs.index(this);
				$('.product-tab-content').removeClass(a).eq(index).addClass(a);
			}) 
			if(!($(window).width() < 1024)) {
				tabs.on('mouseenter', function(){
					tabs.removeClass(a);
					$(this).addClass(a);
					const index = tabs.index(this);
					$('.product-tab-content').removeClass(a).eq(index).addClass(a);
				}) 
			} else {
				tabs.on('click', function() {
					tabs.removeClass(a);
					$(this).addClass(a);
					const index = tabs.index(this);
					$('.product-tab-content').removeClass(a).eq(index).addClass(a);
				}) 
			}
		}
	};
	const slide = () => {
		if($('.product-detail-slide').length) {
			if($('.product-detail-slide .__item').length > 1) {
				$('.product-detail-slide').slick({
					dots:true,
					prevArrow: '<a class="slick-prev" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
					nextArrow: '<a class="slick-next" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
					customPaging: function(slick,index) {
						var targetImage = slick.$slides.eq(index).find('img').attr('src');
						return '<img src=" ' + targetImage + ' "/>';
					}
				});
				let imgHeight = $('.slick-arrow').eq(1).height() / 2;
				let arrowHeight = $('.slick-slide img').eq(1).height() / 2;
				imgHeight = $('.slick-arrow').eq(1).height() / 2;
				arrowHeight = $('.slick-slide img').eq(1).height() / 2;
				$('.slick-arrow').css('top',arrowHeight-imgHeight);
				$(window).resize(function() {
					imgHeight = $('.slick-arrow').eq(1).height() / 2;
					arrowHeight = $('.slick-slide img').eq(1).height() / 2;
					$('.slick-arrow').css('top',arrowHeight-imgHeight);
				});
				$('.product-detail-slide').css('opacity','1');
			} else {
				$('.product-detail-slide').css('opacity','1');
			}
		}
		if($('.product-preservation-slide').length) {
			$('.product-preservation-slide').slick({
				infinite: true,
				speed: 1000,
				autoplay: true,
				autoplaySpeed: 4000,
				slidesToShow: 1,
				arrows: false,
				dots: true,
			});
		}
	};
	tabChange();
	slide();
});